import { gql } from '@apollo/client';

export const PaginatedBrandtypeSamplesQuery = gql`
    query PaginatedBrandtypeSamples(
        $brandtypeGuid: ID
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedBrandtypeSamples(
            brandtypeGuid: $brandtypeGuid
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                bpm
                credits
                duration
                isDownloaded
                isFavorited
                isRecommendationFiller
                name
                sampleType
                waveformUrl
                pack {
                    artworkUrl
                    backgroundColor
                    foregroundColor
                    guid
                    name
                    slug
                    artist {
                        guid
                        slug
                    }
                    label {
                        guid
                        slug
                    }
                }
                key {
                    code
                    root
                    quality
                }
                instruments {
                    code
                    isFamily
                    subInstruments {
                        code
                    }
                }
                sfxs {
                    code
                    subSfxs {
                        code
                    }
                }
                tags {
                    code
                }
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }

            next {
                skip
            }
        }
    }
`;

export const PaginatedBrandtypePacksQuery = gql`
    query PaginatedBrandtypePacks(
        $brandtypeGuid: ID
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedBrandtypePacks(
            brandtypeGuid: $brandtypeGuid
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                artworkUrl
                backgroundColor
                creatorSession
                foregroundColor
                isDownloaded
                isExclusive
                isFavorited
                isFree
                name
                packState
                premiumCodes
                slug
                type
                mainGenre {
                    code
                    subGenres {
                        code
                    }
                }
                genres {
                    code
                    subGenres {
                        code
                    }
                }
                sfxs {
                    code
                    subSfxs {
                        code
                    }
                }
                artist {
                    guid
                    name
                    description
                    artworkUrl
                    portraitUrl
                    coverUrl
                    isExclusive
                    slug
                    seoMetadata {
                        title
                        description
                    }
                }
                label {
                    guid
                    name
                    description
                    artworkUrl
                    coverUrl
                    isExclusive
                    slug
                    seoMetadata {
                        title
                        description
                    }
                }
            }
            meta {
                totalRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
            next {
                skip
            }
        }
    }
`;

export const BrandtypeBySlug = gql`
    query BrandtypeBySlug($slug: String) {
        brandtypeBySlug(slug: $slug) {
            guid
            name
            description
            slug
            sampleCount
            packCount
        }
    }
`;
